<div dropdown vbDropdown #notificationsDropdown="bs-dropdown" class="dropdown" *vbAuthorizationKey="['authenticated', 'distribution.authenticated']" [ngClass]="dropdownCssClass">
	<button dropdownToggle [attr.aria-label]="'Notifications' | translate" class="dropdown-toggle notifications main-nav-btn line-height-1" id="notifications-button" type="button" vbBtnSecondary [ignoreVbBtnPrimary]="!isBaseHeaderBgColor" [ngClass]="[
			notificationsDropdown.isOpen ? 'open' : '',
			isHigh ? 'high': '',
			!isBaseHeaderBgColor ? 'btn': '',
			unreadCount > 99 ? unreadCount > 999 ? 'large-count-bubble' : 'medium-count-bubble' : ''
		]">
		<div class="flex-center-align">
			<span [ngClass]="[
					!notificationsDropdown.isOpen || !showRemove ? 'vb-icon vb-icon-notification' : '',
					notificationsDropdown.isOpen && showRemove ? 'glyphicons remove_2': ''
				]">
			</span>
			<span class="btn-notify notifications-count" *ngIf="unreadCount">
				{{ notificationCount }}
			</span>
		</div>
	</button>
	<div *dropdownMenu id="notification-dropdown" class="notification-menu dropdown-menu dropdown-menu-right keep-border-radius" role="menu" aria-labelledby="notifications-button">
		<notifications-menu-content (close)="notificationsDropdown.isOpen = false">
		</notifications-menu-content>
	</div>
</div>

